goog.provide("shadow.js.shim.module$src$svg$inform$check_circle_svg");
goog.provide("module$shadow_js_shim_module$src$svg$inform$check_circle_svg");
shadow.js.shim.module$src$svg$inform$check_circle_svg = shadow.js.nativeProvides["src/svg/inform/check-circle.svg"] = shadow$bridge("src/svg/inform/check-circle.svg");
module$shadow_js_shim_module$src$svg$inform$check_circle_svg.default = shadow.js.shim.module$src$svg$inform$check_circle_svg;
